import { InferType, mixed, object, string } from 'yup';

export const createZendeskTicketSchemaV2 = object().shape({
    name: string().required(),
    email: string().required().email(),
    subject: string().required(),
    description: string().required(),
    file: mixed().optional(),
    pageSelection: string().oneOf(['thisPage', 'otherPage']).required(),
    persistenceSelection: string().oneOf(['sim', 'não']).required(),
    pageURL: string().when('pageSelection', {
        is: 'thisPage',
        then: (schema) =>
            schema
                .required()
                .url(),
        otherwise: (schema) =>
            schema.when('pageSelection', {
                is: 'otherPage',
                then: (innerSchema) =>
                    innerSchema
                        .required()
                        .url(),
                otherwise: (innerSchema) => innerSchema.optional(),
            }),
    }),
});

export type CreateZendeskTicketV2 = InferType<
    typeof createZendeskTicketSchemaV2
>;
